<template>
    <div class="header-cell" :class="headerCssClass">
        {{ header.title }}
        <div class="header-helper" v-if="header.helper">
            <component :is="header.helper"/>
        </div>
        <span class="subtext" v-if="header.subTitle">{{ header.subTitle }}</span>
    </div>
</template>

<script>
import kebabCase from 'lodash/kebabCase';

export default {
    props: ['header'],
    computed: {
        headerCssClass() {
            return [kebabCase(this.header.key)].concat(
                this.header.cssClasses || [],
            );
        },
    },
};
</script>
